<script setup lang="ts">
const KeepAliveProps = {
  include: ['Objects', 'Events', 'Animals', 'Owners'],
};

const { locale } = useI18n();
const i18nHead = useLocaleHead();

useHead(() => ({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang || locale.value,
    dir:
      i18nHead.value.htmlAttrs?.dir || (locale.value === 'he' ? 'rtl' : 'ltr'),
  },
}));
</script>

<template>
  <NuxtLayout>
    <NuxtPage :keepalive="KeepAliveProps" />
  </NuxtLayout>
</template>

<style></style>
